import styled, { css } from 'styled-components';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { FlexCenter } from '../../../global/commonStyle';

interface Props {
  variant?: number;
  size?: number;
  iconColorType?: 'primary' | 'secondary';
  btnType?: 'rounded' | 'square';
  isDisabled?: boolean;
  isMultiColor?: boolean;
}

const getIconSize = (props: Props) => {
  if (
    props.size === ICON_BUTTON_SIZE.EXTRA_X_LARGE ||
    props.size === ICON_BUTTON_SIZE.EXTRA_LARGE ||
    props.size === ICON_BUTTON_SIZE.LARGE
  )
    return '20px';
  if (props.size === ICON_BUTTON_SIZE.MEDIUM || props.size === ICON_BUTTON_SIZE.SMALL) return '16px';
  if (props.size === ICON_BUTTON_SIZE.EXTRA_SMALL) return '14px';
  return '12px';
};

export const IconWrapper = styled.button<Props>`
  ${FlexCenter}
  cursor: pointer;
  border: unset;
  border-radius: ${({ size, btnType }) =>
    btnType === 'rounded'
      ? 'var(--border-radius-full)'
      : size === ICON_BUTTON_SIZE.EXTRA_X_LARGE ||
        size === ICON_BUTTON_SIZE.EXTRA_LARGE ||
        size === ICON_BUTTON_SIZE.LARGE ||
        size === ICON_BUTTON_SIZE.MEDIUM
      ? 'var(--border-radius-8)'
      : size === ICON_BUTTON_SIZE.SMALL
      ? 'var(--border-radius-6)'
      : 'var(--border-radius-4)'};
  padding: ${({ size }) =>
    size === ICON_BUTTON_SIZE.EXTRA_X_LARGE
      ? 'var(--space-9)'
      : size === ICON_BUTTON_SIZE.EXTRA_LARGE
      ? 'var(--space-8)'
      : size === ICON_BUTTON_SIZE.LARGE
      ? 'var(--space-6)'
      : size === ICON_BUTTON_SIZE.MEDIUM
      ? 'var(--space-5)'
      : size === ICON_BUTTON_SIZE.SMALL
      ? 'var(--space-4)'
      : 'var(--space-3)'};
  background-color: ${({ variant }) =>
    variant === ICON_BUTTON_TYPE.PRIMARY
      ? 'var(--brand-primary)'
      : variant === ICON_BUTTON_TYPE.SECONDARY
      ? 'var(--background-primary)'
      : 'transparent'};

  /* svg width and height on the basis of size */
  svg {
    width: ${({ size }) => getIconSize({ size })};
    height: ${({ size }) => getIconSize({ size })};
    path {
      ${({ isMultiColor, iconColorType, variant }) =>
        !isMultiColor &&
        css`
          fill: ${variant === ICON_BUTTON_TYPE.PRIMARY
            ? 'var(--text-white)'
            : iconColorType === 'primary'
            ? 'var(--text-primary)'
            : 'var(--text-secondary)'};
        `}
    }
  }
  /* hover state */
  &:hover {
    background-color: ${({ variant }) =>
      variant === ICON_BUTTON_TYPE.PRIMARY
        ? 'var(--brand-primary-hover)'
        : variant === ICON_BUTTON_TYPE.SECONDARY
        ? 'var(--background-secondary)'
        : 'var(--neutral-secondary)'};
    svg path {
      ${({ isMultiColor, iconColorType, variant }) =>
        !isMultiColor &&
        css`
          fill: ${variant === ICON_BUTTON_TYPE.PRIMARY
            ? 'var(--text-white)'
            : iconColorType === 'primary'
            ? 'var(--text-primary)'
            : 'var(--text-primary)'};
        `}
    }
    // Apply filter ONLY for multicolor
    ${({ isMultiColor }) =>
      isMultiColor &&
      css`
        svg {
          filter: brightness(var(--brightness-value));
          .transparent-fill {
            fill: none;
          }
          .desktop-fill {
            fill: transparent;
          }
        }
      `}
  }

  /* border for secondary variant */
  ${({ variant }) =>
    variant === ICON_BUTTON_TYPE.SECONDARY &&
    css`
      box-shadow: var(--border);
      &:hover {
        box-shadow: var(--button-border-hover);
      }
      ${mobile_xl(css<Props>`
        &:hover {
          box-shadow: var(--border);
        }
      `)}
    `}
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      svg path {
        fill: var(--text-muted);
      }
      &:hover {
        background: transparent;
        svg path {
          fill: var(--text-muted);
        }
      }
    `}
  ${mobile_xl(css<Props>`
    &:hover {
      background-color: ${({ variant }) =>
        variant === ICON_BUTTON_TYPE.PRIMARY
          ? 'var(--brand-primary)'
          : variant === ICON_BUTTON_TYPE.SECONDARY
          ? 'var(--background-primary)'
          : 'transparent'};
      svg path {
        fill: ${({ iconColorType }) => (iconColorType === 'primary' ? 'var(--text-primary)' : 'var(--text-secondary)')};
      }
    }
  `)}
`;
